(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biocare-entree-pdp"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bc-pdp .bc-faq-q').forEach(function(q){
  q.addEventListener('click', function(){ q.parentElement.classList.toggle('bc-open'); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biocare-pdp"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bc-pdp .bc-faq-q').forEach(function(q){
  q.addEventListener('click', function(){ q.parentElement.classList.toggle('bc-open'); });
});

  } catch(e) { console.error(e); }
})();
})();
